import Swiper from 'swiper';

class SingleMethode {

  constructor() {
    this._initSwiper();
  }

  _initSwiper() {

    new Swiper('.single-methode-list__list', {
      direction: 'horizontal',
      slidesPerView: 1.2,
      spaceBetween: 20,
      grabCursor: true,
      mousewheel: true,
      preventInteractionOnTransition: true,
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 24
        },
      }
    });
  }

}

export const singleMethode = new SingleMethode();